<div class="synthesis-executions-container p-5 d-flex align-items-center mb-5"
  *ngIf="!!synthesisExecutions">
  <ibm-loading class="mr-5"></ibm-loading>
  <span class="mr-5">{{ synthesisExecutions }} Synthesis executions in progress</span>
  <a [routerLink]="['..','synthesis','executions']"
    *ngIf="showListLink">View</a>
</div>